import styled from '@emotion/styled'
import { stylesIf } from 'utils/styles'
import { isBoolean } from 'utils/types'

const getGateFillColor = (isSelected, simulatedValue, isSimulating, theme) => {
  const { featureGatesDefault, featureGatesSelectedColor, color } = theme
  if (isBoolean(simulatedValue))
    return simulatedValue ? color.confirmPrimary : color.errorPrimary
  // Empty gate (null) during simulation means no conditions are configured — show red
  if (isSimulating && simulatedValue === null) return color.errorPrimary
  if (isSelected) return featureGatesSelectedColor

  return featureGatesDefault
}

export const LogicGateSVG = styled.svg((props) => {
  const { isSelected, simulatedValue, isSimulating, theme } = props
  return `
    position: relative;
    z-index: 1;
      .selection {
        fill: ${getGateFillColor(
          isSelected,
          simulatedValue,
          isSimulating,
          theme
        )};
      }
    `
})

export const StyledQueryOperator = styled.span((props) => {
  const { isSelected, type, abGateSimVal, cdGateSimVal, isSimulating, theme } =
    props

  const AbIntermediateGateStyle = `
      top: 14px;
      left: 8px;
      &::before{
        border-bottom: 2px solid ${getGateFillColor(
          isSelected,
          abGateSimVal,
          isSimulating,
          theme
        )};
        position: absolute;
        height: 1px;
        top: 8px;
        left: -10px;
        width: 21.5px;
        content: '';
        z-index: 2;
      }
      &::after{
        border-top: 2px solid ${getGateFillColor(
          isSelected,
          abGateSimVal,
          isSimulating,
          theme
        )};
        position: absolute;
        height: 1px;
        bottom: 13.25px;
        left: -10px;
        width: 21.5px;
        content: '';
        z-index: 1;
      }
    `
  const CdIntermediateGateStyle = `
      top: 47px;
      left: 8px;
      &::before{
        border-bottom: 2px solid ${getGateFillColor(
          isSelected,
          cdGateSimVal,
          isSimulating,
          theme
        )};
        position: absolute;
        height: 1px;
        top: 8px;
        left: -10px;
        width: 21.5px;
        content: '';
        z-index: 2;
      }
      &::after{
        border-top: 2px solid ${getGateFillColor(
          isSelected,
          cdGateSimVal,
          isSimulating,
          theme
        )};
        position: absolute;
        height: 1px;
        bottom: 13.25px;
        left: -10px;
        width: 21.5px;
        content: '';
        z-index: 1;
      }
    `
  const finalGateStyle = `
      pointer-events: none;
      width:70px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      height: 100%;
      bottom: 40px;
      left: 40px;
      &::before{
        border-left: 2px solid ${getGateFillColor(
          isSelected,
          abGateSimVal,
          isSimulating,
          theme
        )};
        border-bottom: 2px solid ${getGateFillColor(
          isSelected,
          abGateSimVal,
          isSimulating,
          theme
        )};
        border-bottom-left-radius: 8px;
        position: absolute;
        height: 17px;
        top: 7.15px;
        right: 48px;
        width: 32.5px;
        content: '';
        z-index: 2;
      }
      &::after{
        border-top: 2px solid ${getGateFillColor(
          isSelected,
          cdGateSimVal,
          isSimulating,
          theme
        )};
        border-left: 2px solid ${getGateFillColor(
          isSelected,
          cdGateSimVal,
          isSimulating,
          theme
        )};
        border-top-left-radius: 8px;
        position: absolute;
        height: 17px;
        bottom: 8.25px;
        right: 48px;
        width: 32.5px;
        content: '';
        z-index: 1;
        }
      }
    `
  return `
      z-index: 1;
      width: 100%;
      position: relative;
      ${stylesIf(type === 'ab', AbIntermediateGateStyle)}
      ${stylesIf(type === 'cd', CdIntermediateGateStyle)}
      ${stylesIf(type === 'xyz', finalGateStyle)}
    `
})
